import React from 'react';

const SIZE_CLASS = {
  sm: 'h-7 w-7',
  md: 'h-10 w-10',
  lg: 'h-14 w-14',
};

/**
 * Gradient ring spinner — indigo / violet brand colors.
 */
function Spinner({ size = 'md', className = '', label = 'Loading' }) {
  const dim = SIZE_CLASS[size] || SIZE_CLASS.md;

  return (
    <div
      className={`relative ${dim} ${className}`}
      role="status"
      aria-label={label}
    >
      <div className="absolute inset-0 rounded-full border-[3px] border-indigo-100/90" aria-hidden />
      <div
        className="absolute inset-0 rounded-full border-[3px] border-transparent border-t-indigo-600 border-r-violet-500 animate-spin"
        aria-hidden
      />
      <div
        className="absolute inset-[26%] rounded-full bg-gradient-to-br from-indigo-500 via-violet-500 to-cyan-400 opacity-90 shadow-[0_0_18px_rgba(99,102,241,0.45)] animate-pulse"
        aria-hidden
      />
    </div>
  );
}

export default Spinner;
